<template>
	<div class="form-group">
		<!-- <label :for="id">{{ label }}</label> -->

		<textarea
		v-validate="validate"

		class="form-control"
		:class="{'is-invalid': errors.has(name)}"

		:id="id"
		:name="name"
		:rows="rows"
		:placeholder="placeholder"
		v-model="real_value"
		v-on:input="$emit('input', $event.target.value)">
		</textarea>

		<div v-if="errors.has(name)" class="invalid-feedback">{{ errors.first(name) }}</div>
	</div>
</template>

<script>

export default {
	name: 'CsTextarea',
	inject: ['$validator'],
	props: {
		validate: {
			default: ''
		},
		// base
		value: {
			type: String,
			default: ''
		},

		id: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},

		rows: {
			type: Number,
			default: 3
		},
		prefilled: {
			type: String,
			default: ''
		},


		// statussen
		disabled: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: ''
		},


		// misc

	},
	data(){
		return {
			real_value: this.prefilled
		}
	},
	watch: {
		value(newValue){
			if(this.real_value != newValue){
				this.real_value = newValue;
			}
		}
	}
}
</script>

<style lang="scss">
@import '../../styles/config';

</style>



// WEBPACK FOOTER //
// src/components/Forms/CsTextarea.vue